import React, { Fragment } from 'react'
import SiteFooter from '../components/SiteFooter';
import { about, advisor, contact, faq } from '../content/siteContent';

function AboutUs(){
    return(
        <Fragment>
            <div className="boxed_wrapper ltr">
                {/* Mobile Menu  */}
                <div className="mobile-menu">
                    <div className="menu-backdrop"></div>
                    <div className="close-btn"><i className="fas fa-times"></i></div>
                    
                    <nav className="menu-box">
                        <div className="nav-logo"><a href="/"><img src="assets/images/logo-4.png" alt="H.J. Enterprises" title=""/></a></div>
                        <div className="menu-outer">{/*Here Menu Will Come Automatically Via Javascript / Same Menu as in Header*/}</div>               
                    </nav>
                </div>{/* End Mobile Menu */}


                {/* page-title */}
                <section className="page-title centred">
                    <div className="bg-layer" style={{backgroundImage: "url(assets/images/background/page-title.jpg)"}}></div>
                    <div className="pattern-layer">
                        <div className="pattern-1" style={{backgroundImage: "url(assets/images/shape/shape-18.png)"}}></div>
                        <div className="pattern-2" style={{backgroundImage: "url(assets/images/shape/shape-17.png)"}}></div>
                    </div>
                    <div className="auto-container">
                        <div className="content-box">
                            <h1>About Us</h1>                   
                        </div>
                    </div>
                </section>
                {/* page-title end */}

                {/* about-section */}
                    <section className="about-section pt_70 pb_70">
                        <div className="pattern-layer rotate-me"></div>
                        <div className="auto-container">
                            <div className="row clearfix">
                                <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                                    <div className="image_block_one">
                                        <div className="image-box pr_90 mr_40">
                                            <div className="image-shape" style={{backgroundImage: "url(assets/images/shape/shape-3.png)"}}></div>
                                            <figure className="image"><img src="assets/images/site/hero-opening-doors.jpg" alt="H.J. Enterprises"/></figure>
                                            
                                            <div className="experience-box">
                                                <div className="inner">
                                                    <h6>{contact.location}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                                    <div className="content_block_one">
                                        <div className="content-box ml_40">
                                            <div className="sec-title mb_20">										
												<h2>{about.title}</h2>
                                            </div>
                                            <div className="text-box mb_40">
                                                <p>{about.body}</p>
                                                <p>{about.lead}</p>
                                                <p>{about.visionLabel}</p>
                                                <p>“{about.vision}”</p>
                                            </div>
                                            <div className="btn-box">
                                                <a href="/contactus" className="theme-btn btn-one">Contact Us</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                {/* about-section end */}


                {/* funfact-section */}
                    <section className="funfact-section about-page pt_95 pb_120">
                        <div className="auto-container">
                            <div className="inner-container clearfix">
                                <div className="funfact-block-one">
                                    <div className="inner-box">
                                        <div className="icon-box"><i className="icon-21"></i></div>
                                        <div className="count-outer count-box">
                                            <span className="count-text" data-speed="1500" data-stop="4">0</span><span>k+</span>
                                        </div>
                                        <p>Happy Clients</p>
                                    </div>
                                </div>
                                <div className="funfact-block-one">
                                    <div className="inner-box">
                                        <div className="icon-box"><i className="icon-22"></i></div>
                                        <div className="count-outer count-box">
                                            <span className="count-text" data-speed="1500" data-stop="6">0</span><span>k+</span>
                                        </div>
                                        <p>Total Transactions</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                {/* funfact-section end */}

                <section className="about-section pt_70 pb_40">
                    <div className="auto-container">
                        <div className="sec-title mb_20">
                            <h2>{advisor.heading}</h2>
                        </div>
                        <h3>{advisor.name}</h3>
                        <p><strong>{advisor.role}</strong></p>
                        <p>{advisor.bio}</p>
                        <p>{advisor.support}</p>
                        <p>Mobile: <a href={contact.phoneTel}>{contact.phone}</a></p>
                        <p>
                            Email: <a href={contact.emailMailto}>{contact.email}</a>
                            <br />
                            Email: <a href={contact.emailSecondaryMailto}>{contact.emailSecondary}</a>
                        </p>
                        <p>Location: {contact.location}</p>
                    </div>
                </section>

                <section className="faq-section pt_70 pb_70">
                    <div className="auto-container">
                        <div className="sec-title centred mb_40">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                        <ul className="accordion-box">
                            {faq.map((item) => (
                                <li className="accordion block" key={item.question}>
                                    <div className="acc-btn">
                                        <div className="icon-box"></div>
                                        <h4>{item.question}</h4>
                                    </div>
                                    <div className="acc-content">
                                        <p>{item.answer}</p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </section>

                <SiteFooter />
                {/* main-footer end */}

                {/*Scroll to top*/}
                <div className="scroll-to-top">
                    <div>
                        <div className="scroll-top-inner">
                            <div className="scroll-bar">
                                <div className="bar-inner"></div>
                            </div>
                            <div className="scroll-bar-text">Go To Top</div>
                        </div>
                    </div>
                </div>
                {/* Scroll to top end */}
                
            </div>
        </Fragment>
    )
}

export default AboutUs;